module.exports = __webpack_public_path__ + "img/weights.f7a70a55.jpg";